module.exports = __webpack_public_path__ + "VAGRoundedStd-Black.da2045238fd4de6faddf.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.eot
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.eot
// module chunks = styles